const calculateCuti = (
  filteredStaf,
  dataCuti,
  dataGroupStaf,
  dataTipeAbsensi
) => {
  let newList = filteredStaf?.map((staf) => {
    const filteredCuti = dataCuti.filter((cuti) => staf.id === cuti.id_user);
    const groupStaf = dataGroupStaf.find(
      (groupStaf) => groupStaf.id_group === staf.group_staf
    );

    const maxCuti =
      groupStaf?.max_cuti !== undefined ? groupStaf?.max_cuti : 12;

    let sakitCount = 0,
      ijinCount = 0,
      alpaCount = 0,
      cutiCount = 0,
      usedCuti = 0;

    filteredCuti.forEach((cuti) => {
      let msDay = 24 * 60 * 60 * 1000;
      let dayUsed = 0;

      for (
        let day = new Date(cuti.tanggal_mulai_cuti).getTime();
        day <= new Date(cuti.tanggal_selesai_cuti).getTime();
        day += msDay
      ) {
        dayUsed += new Date(day).getDay() % 6 !== 0 ? 1 : 0;
      }

      sakitCount += filterCuti(cuti, "sakit") * dayUsed;
      ijinCount += filterCuti(cuti, "ijin") * dayUsed;
      alpaCount += filterCuti(cuti, "alpa") * dayUsed;
      cutiCount += filterCuti(cuti, "cuti") * dayUsed;
      usedCuti +=
        (dataTipeAbsensi.find(
          (tipeAbsensi) =>
            tipeAbsensi.nama_tipe_absensi === cuti.id_tipe_absensi
        )?.mengurangi_jatah_cuti ===
          "Y") *
        dayUsed;
    });

    return {
      ...staf,
      sakitCount: sakitCount,
      ijinCount: ijinCount,
      alpaCount: alpaCount,
      cutiCount: cutiCount,
      jatahCuti: maxCuti - usedCuti,
      hasGroup: groupStaf?.max_cuti === undefined,
    };
  });

  return newList;
};

export default calculateCuti;

const filterCuti = (cuti, filterStr) =>
  cuti.id_tipe_absensi.toLowerCase().includes(filterStr);
